import { useState, useEffect } from 'react';
import { 
  MdBusiness, 
  MdPeople, 
  MdConfirmationNumber, 
  MdTrendingUp,
  MdTrendingDown,
  MdCheckCircle
} from 'react-icons/md';
import api from '../config/axios';
import { useLanguage } from '../context/LanguageContext';

const SuperAdminDashboardPage = () => {
  const { t } = useLanguage();
  const [stats, setStats] = useState({
    totalCompanies: 0,
    activeCompanies: 0,
    totalAgents: 0,
    totalTickets: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const token = localStorage.getItem('superadmin_token');
      const response = await api.get('/superadmin/dashboard/stats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error(t('superAdmin.dashboardStatsLoadError'), error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: t('superAdmin.totalCustomers'),
      value: stats.totalCompanies,
      icon: <MdBusiness size={24} />,
      color: 'bg-blue-500',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: t('superAdmin.activeCustomers'),
      value: stats.activeCompanies,
      icon: <MdCheckCircle size={24} />,
      color: 'bg-green-500',
      change: '+8%',
      changeType: 'positive'
    },
    {
      title: t('superAdmin.totalAgents'),
      value: stats.totalAgents,
      icon: <MdPeople size={24} />,
      color: 'bg-purple-500',
      change: '+15%',
      changeType: 'positive'
    },
    {
      title: t('superAdmin.totalTickets'),
      value: stats.totalTickets,
      icon: <MdConfirmationNumber size={24} />,
      color: 'bg-orange-500',
      change: '+5%',
      changeType: 'positive'
    }
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Başlık */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {t('superAdmin.dashboard')}
        </h1>
      
      </div>

      {/* İstatistik Kartları - Responsive Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {statCards.map((card, index) => (
          <div key={index} className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex flex-col sm:flex-row h-full">
              {/* Sol Renkli Bölüm - Icon (Mobilde üst, masaüstünde sol) */}
              <div className={`${card.color} w-full sm:w-20 lg:w-24 h-16 sm:h-auto flex items-center justify-center relative`}>
                <div className="text-white">
                  {card.icon}
                </div>
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
              </div>
              
              {/* Sağ İstatistik Bölümü */}
              <div className="flex-1 p-4 sm:p-6">
                <div className="space-y-2 sm:space-y-3">
                  {/* Başlık */}
                  <p className="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wide">
                    {card.title}
                  </p>
                  
                  {/* Ana Değer */}
                  <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
                    {card.value.toLocaleString()}
                  </p>
                  
                  {/* Değişim Bilgisi */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-0">
                    <div className={`flex items-center px-2 py-1 rounded-full text-xs font-medium w-fit ${
                      card.changeType === 'positive' 
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' 
                        : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                    }`}>
                      {card.changeType === 'positive' ? (
                        <MdTrendingUp className="mr-1" size={12} />
                      ) : (
                        <MdTrendingDown className="mr-1" size={12} />
                      )}
                      {card.change}
                    </div>
                    <span className="text-xs text-gray-500 dark:text-gray-400 sm:ml-2">
                      {t('superAdmin.comparedToLastMonth')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>


    </div>
  );
};

export default SuperAdminDashboardPage;
